import { SettingsResCommon } from '@/views/dashboard/policy/policy-common.service'
import { StrategySettings } from '@/views/dashboard/data-safe/screen-watermark/screen-watermark.service'
import { i18n } from '@/i18n'
export const DEFAULT_SETTING: StrategySettings = {
  main_switch: true,
  type: 1,
  software_process: [],
  process_infos: [{}],
  wmdata: {
    fields: ['user_mark', 'group_id'],
    custom_text: i18n.global.t('screenWatermark.fieldCustomText'),
    density: 2,
    rotate_angle: 30,
    mark_type: 2,
    opacity: 15,
  }
}

export interface SettingsRes extends SettingsResCommon {
  /** 策略内容(json) ，特定的类型才返回，如软件禁用策略 */
  strategy: StrategySettings
}
